import { z } from "zod";
import { BlogAudience } from "@/gql/graphql";

const slugSchema = z
  .string()
  .min(2, "Slug must be at least 2 characters long")
  .regex(
    /^[a-z0-9]+(?:-[a-z0-9]+)*$/,
    "Slug must contain only lowercase letters, numbers, and hyphens",
  );

export const blogPostCreateValidation = z.object({
  slug: slugSchema,
  locale: z.string().min(2).default("en"),
  title: z.string().min(2, "Title must be at least 2 characters long"),
  excerpt: z.string().nullable().optional(),
  blog_author_id: z.string().nullable().optional(),
  audience: z.enum(BlogAudience),
});

export const blogPostDetailsValidation = z.object({
  slug: slugSchema,
  locale: z.string().min(2).default("en"),
  title: z.string().min(2, "Title must be at least 2 characters long"),
  excerpt: z.string().nullable().optional(),
  blog_author_id: z.string().nullable().optional(),
  audience: z.enum(BlogAudience),
});

export const blogPostContentValidation = z.object({
  body_html: z.string(),
});

export type BlogPostDetailsInput = z.infer<typeof blogPostDetailsValidation>;
export type BlogPostContentInput = z.infer<typeof blogPostContentValidation>;

export const blogAuthorValidation = z.object({
  name: z.string().min(2, "Name must be at least 2 characters long"),
  role: z.string().nullable().optional(),
  bio: z.string().nullable().optional(),
});

export const blogTagValidation = z.object({
  name: z.string().min(2),
  slug: z
    .string()
    .min(2)
    .regex(
      /^[a-z0-9]+(?:-[a-z0-9]+)*$/,
      "Slug must contain only lowercase letters, numbers, and hyphens",
    ),
});
